import Auth from '../api/auth';

// NOTICE: KAPTION-INTEGRATION - feature-permissions.CORE.6: tag feature_not_permitted
// 401s (the stable code the KaptionFeatureAuthorization concern renders) so any caller
// can detect a refused governed feature uniformly — via err.isFeatureNotPermitted — and
// degrade to hidden/silent instead of surfacing the raw error string to the user.
const parseErrorCode = error => {
  if (
    error?.response?.status === 401 &&
    error?.response?.data?.error === 'feature_not_permitted'
  ) {
    error.isFeatureNotPermitted = true;
  }
  return Promise.reject(error);
};

// NOTICE: KAPTION-INTEGRATION - Helper to read local flag overrides from localStorage
const LOCAL_OVERRIDES_STORAGE_KEY = 'kaption_feature_flag_overrides';

const getLocalFlagOverrides = () => {
  try {
    const stored = localStorage.getItem(LOCAL_OVERRIDES_STORAGE_KEY);
    if (!stored) return null;
    const overrides = JSON.parse(stored);
    // Only return if there are actual overrides
    if (Object.keys(overrides).length > 0) {
      return overrides;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }

  // NOTICE: KAPTION-INTEGRATION - Request interceptor to send local flag overrides
  // Only send overrides in development environment for security
  wootApi.interceptors.request.use(
    config => {
      // Only enable flag overrides in development mode
      if (import.meta.env.MODE === 'development') {
        const overrides = getLocalFlagOverrides();
        if (overrides) {
          // Add the overrides as a JSON-stringified header
          config.headers['X-Kaption-Flag-Overrides'] =
            JSON.stringify(overrides);
        }
      }
      return config;
    },
    error => Promise.reject(error)
  );

  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
